<template lang="pug">
  DataGrid(
    emptyMessage="No activations found for this roll"
    :fetch="fetchData" @error="$emit('error', $event)")
    tr(slot="thead")
      th Section
      th Created
      th Created by
      th Product
      th Size
    tr(v-if="!isCalibrated")
      td(colspan="5")
        div(style="padding:10px")
          button.btn.btn-default(@click="$emit('calibrate')") Calibrate
          img(src="../../../../assets/icon-info.svg",style="width:24px;height:24px;margin:0 6px 0 12px")
          span(style="color:#004fe1") Roll is not calibrated
    tr(v-if="isFullyActivated")
      td(colspan="5")
        div(style="padding:10px")
          img(src="../../../../assets/icon-success.svg",style="width:24px;height:24px;margin:0 6px 0 0")
          span(style="color:#469e49") Roll is fully activated

    tr(v-if="isCalibrated && !isFullyActivated")
      td(colspan="5")
        div(style="padding:10px")
          button.btn.btn-primary(@click="$emit('nextActivation')") New Activation
    tr(v-for="section in sections" @click="$emit('row-click', section)" style="cursor:pointer")
      td {{section.id}}
      td {{section.created | date}}
      td {{section.createdBy.username}}
      td {{section.product.name}}
      td {{Math.abs(section.first.codeIndex - section.last.codeIndex) + 1 }}
</template>
<script>
import DataGrid from '@/components/ssp/DataGrid'
import { dateFilter } from '@/filters/filters'
import activationSession from '../service/ActivationSession'

export default {
  props: ['code', 'isFullyActivated', 'isCalibrated'],
  data: () => ({
    sections: null
  }),
  methods: {
    fetchData(page) {
      const req = page.pageRequest()
      return activationSession.getActivations(this.code, req)
        .then((resp) => {
          this.sections = resp.data.content
          return resp.data.totalElements
        })
        .catch((e) => { this.$emit('error', e) })
    }
  },
  components: {
    DataGrid
  },
  filters: {
    date: dateFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/activator/components/ActivationsTable.vue